import { render, staticRenderFns } from "./formChangeMail.vue?vue&type=template&id=655ec9e7&"
import script from "./formChangeMail.vue?vue&type=script&lang=js&"
export * from "./formChangeMail.vue?vue&type=script&lang=js&"
import style0 from "./formChangeMail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports